/**
 * search_unify1 s-ui — 「{지역} 인기 단지」 목록 행(한 벌): 홈 섹션 · 검색 드롭다운/시트 · 상세 사이드 · 지역 허브.
 * 행(min-height 58) = 순위(17/800 · 1~3위 navy) | 단지명 15/700 + 「시군구 · N세대」 12.5 | 단계 배지(색 4종) + 순위 변화(▲▼–NEW).
 * 데이터는 받은 값만(세대·단계 없으면 칸째 생략 · 수치 지어내기 0). 훅 없음 — 서버·클라이언트 어디서나.
 */
import React from 'react'; // vitest(클래식 JSX) 렌더 검증용
import { popularSiteMeta, rankChange, type PopularSite } from '@/lib/search/pop-region';
import { displaySiteName, placeOf, sidoKey } from '@/lib/search/subline';
import '@/components/nav/kd-gs.css';
import Thumb from '@/components/thumb/Thumb';
import { popularThumbOf } from '@/lib/search/pop-region';

export const siteHrefOf = (slug: string) => `/apt/${encodeURIComponent(slug)}`;

export function PopularSiteRow({ s, onPick, region = null, thumbs = false }: { s: PopularSite; onPick?: (s: PopularSite) => void; region?: string | null; /** thumb-lists — 순위 뒤 48px 썸네일(홈·허브 섹션만). */ thumbs?: boolean }) {
  const meta = popularSiteMeta(s);
  // #4g.3 — 목록 표시 이름: 앞 「시도 시군구」 접두 제거(보조줄에 지역이 있다 · 시군구명이 이름 본체면 그대로).
  const shown = displaySiteName(s.name, { region, sigungu: s.sigungu });
  const ch = rankChange(s.rank, s.prevRank);
  return (
    <li>
      <a className="kd-pop__row" href={siteHrefOf(s.slug)} onClick={onPick ? () => onPick(s) : undefined} data-pop-slug={s.slug}>
        <span className={s.rank <= 3 ? 'kd-pop__rk kd-pop__rk--top' : 'kd-pop__rk'}>{s.rank}</span>
        {thumbs ? <Thumb data={s.thumb ?? popularThumbOf(null, s)} w={48} h={48} className="kd-pop__th" /> : null}
        <span className="kd-pop__body">
          <span className="kd-pop__nm">{shown}</span>
          {meta ? <span className="kd-pop__meta">{meta}</span> : null}
        </span>
        <span className="kd-pop__end">
          {s.stageLabel ? <span className="kd-pop__stage" data-tone={s.stageTone}>{s.stageLabel}</span> : null}
          <span className="kd-pop__chg" data-chg={ch.kind} aria-label={ch.aria}>{ch.text}</span>
        </span>
      </a>
    </li>
  );
}

export default function PopularSiteList({ sites, label, limit = 10, onPick, thumbs = false }: { sites: readonly PopularSite[]; label: string; limit?: number; onPick?: (s: PopularSite) => void; thumbs?: boolean }) {
  const list = sites.slice(0, limit);
  const region = placeOf(label).region ?? sidoKey(label);
  if (!list.length) return null;
  return (
    <ol className="kd-pop__list" aria-label={`${label} 인기 단지`}>
      {list.map((s) => <PopularSiteRow key={s.slug} s={s} onPick={onPick} region={region} thumbs={thumbs} />)}
    </ol>
  );
}
